export default function() {
  const searchBtn = document.querySelector('.search-icon');
  const searchBar = document.querySelector('.search-bar');
  const siteSearch = document.querySelector('#site-search');
  let aria = searchBtn.getAttribute('aria-expanded');

  searchBtn.addEventListener('click', () => {
    aria = searchBtn.getAttribute('aria-expanded');

    if (aria === 'false') {
      searchBar.classList.add('active');

      siteSearch.classList.remove('collapse');
      siteSearch.classList.add('collapsing');

      addHeight();
      aria = 'true';
      searchBtn.setAttribute('aria-expanded', 'true');
    } else if (aria === 'true') {
      searchBar.classList.remove('active');
      siteSearch.classList.remove('show');

      siteSearch.classList.remove('collapse');
      siteSearch.classList.add('collapsing');
      addHeight();
      aria = 'false';
      searchBtn.setAttribute('aria-expanded', 'false');
    }

    transitionEnd(siteSearch, aria);
  });

  const transitionEnd = (siteSearch, aria) => {
    siteSearch.addEventListener('transitionend', e => {
      if (e.propertyName === 'height' && aria === 'true') {
        siteSearch.classList.remove('collapsing');
        siteSearch.classList.add('collapse');
        siteSearch.classList.add('show');
      } else if (e.propertyName === 'height' && aria === 'false') {
        siteSearch.classList.remove('collapsing');
        siteSearch.classList.add('collapse');
        siteSearch.classList.remove('show');
      }
    });
  };

  const addHeight = () => {
    if (siteSearch.style.height !== siteSearch.scrollHeight + 'px') {
      siteSearch.style.height = siteSearch.scrollHeight + 'px';
    } else {
      siteSearch.style.height = '';
    }
  };
}
